import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row row-layout mb-4" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "row row-title align-items-end mb-4" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row row-content mb-5" }
const _hoisted_9 = { class: "row row-symbol mb-5" }
const _hoisted_10 = { class: "col-4 col-cb-preview" }
const _hoisted_11 = { class: "col-8 col-cb-settings" }
const _hoisted_12 = { class: "row row-position mb-4" }
const _hoisted_13 = { class: "col-auto" }
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = { class: "row row-reference" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row row-button mb-5" }
const _hoisted_18 = { class: "col-12 mb-3" }
const _hoisted_19 = {
  key: 0,
  class: "col-12"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-8" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-4" }
const _hoisted_24 = { class: "col-auto" }
const _hoisted_25 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_AdvancedPanelSwitcher = _resolveComponent("AdvancedPanelSwitcher")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TitleMetaInputComponent = _resolveComponent("TitleMetaInputComponent")!
  const _component_AdvancedPanel = _resolveComponent("AdvancedPanel")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_PreviewSymbol = _resolveComponent("PreviewSymbol")!
  const _component_MaterialSymbolInputComponent = _resolveComponent("MaterialSymbolInputComponent")!
  const _component_PageLinkPicker = _resolveComponent("PageLinkPicker")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.contentBlock.layout_code,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.layout_code) = $event)),
                  _ctx.onChange
                ],
                label: _ctx.$t('layout'),
                name: "layout",
                selectText: _ctx.$t('selectText'),
                options: _ctx.enumLayoutCode,
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "selectText", "options", "errors"])
            ])
          ]),
          _createVNode(_component_Subtitle, {
            title: _ctx.$t('content')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AdvancedPanelSwitcher, {
                class: "mb-3",
                "is-advanced": _ctx.isAdvancedTitleMeta,
                errors: _ctx.errors,
                onToggleAdvanced: _ctx.toggleAdvancedTitleMeta
              }, null, 8, ["is-advanced", "errors", "onToggleAdvanced"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.contentBlock.title_size_code,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.title_size_code) = $event)),
                  _ctx.onChange
                ],
                label: _ctx.$t('size'),
                name: "title_size_code",
                selectText: _ctx.$t('selectText'),
                options: _ctx.enumTitleSizeCode,
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "selectText", "options", "errors"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.contentBlock.title.nl,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.title.nl) = $event)),
                  _ctx.onChange
                ],
                label: _ctx.$t('title'),
                name: "title",
                rules: "max:500",
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
            ])
          ]),
          _createVNode(_component_AdvancedPanel, {
            "is-show-when-advanced": true,
            "is-advanced": _ctx.isAdvancedTitleMeta,
            class: "bg-light pt-3 ms-3 mb-3 p-3 pt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TitleMetaInputComponent, {
                modelValue: _ctx.contentBlock.title_meta,
                errors: _ctx.errors,
                "onUpdate:modelValue": _ctx.onTitleMetaUpdate
              }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["is-advanced"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_InputTextEditor, {
              modelValue: _ctx.contentBlock.content.nl,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.content.nl) = $event)),
                _ctx.onChange
              ],
              name: "content",
              class: "col-12",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "errors"])
          ]),
          _createVNode(_component_Subtitle, {
            title: _ctx.$t('symbol')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_PreviewSymbol, {
                symbol: _ctx.contentBlock.symbol
              }, null, 8, ["symbol"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_MaterialSymbolInputComponent, {
                modelValue: _ctx.contentBlock.symbol.material_symbol,
                errors: _ctx.errors,
                "onUpdate:modelValue": _ctx.onMaterialSymbolUpdate
              }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.alignment')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.symbol.horizontal_position_code,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.symbol.horizontal_position_code) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('cms.horizontal'),
                    name: "horizontal_position_code",
                    selectText: _ctx.$t('selectText'),
                    options: _ctx.enumObjectHorizontalPosition,
                    rules: "required",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.symbol.vertical_position_code,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentBlock.symbol.vertical_position_code) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('cms.vertical'),
                    name: "vertical_position_code",
                    selectText: _ctx.$t('selectText'),
                    options: _ctx.enumVerticalPosition,
                    rules: "required",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                ])
              ]),
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('reference')
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_PageLinkPicker, {
                    payload: _ctx.pageLinkSymbolPayload,
                    errors: _ctx.errors,
                    onChanged: _ctx.onPageLinkPickerSymbolChanged
                  }, null, 8, ["payload", "errors", "onChanged"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_InputCheckboxBoolean, {
                modelValue: _ctx.useButton,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.useButton) = $event)),
                  _ctx.onChange
                ],
                label: _ctx.$t('useButton'),
                name: "useButton",
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
            ]),
            (_ctx.useButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.contentBlock.button.button_text.nl,
                        "onUpdate:modelValue": [
                          _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                          _ctx.onChange
                        ],
                        label: _ctx.$t('buttonText'),
                        placeholder: "buttonText",
                        name: "buttonText",
                        rules: "max:100",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.button_horizontal_position_code,
                        "onUpdate:modelValue": [
                          _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contentBlock.button_horizontal_position_code) = $event)),
                          _ctx.onChange
                        ],
                        label: _ctx.$t('cms.horizontalAlignment'),
                        name: "button_horizontal_position_code",
                        selectText: _ctx.$t('selectText'),
                        options: _ctx.enumObjectHorizontalPosition,
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.button.button_layout_code,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contentBlock.button.button_layout_code) = $event)),
                        options: _ctx.enumButtonLayoutCode,
                        label: _ctx.$t('layout'),
                        name: "buttonLayout",
                        selectText: _ctx.$t('selectText'),
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "options", "label", "selectText", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_PageLinkPicker, {
                        payload: _ctx.pageLinkButtonPayload,
                        "enable-no-link": false,
                        errors: _ctx.errors,
                        onChanged: _ctx.onPageLinkPickerButtonChanged
                      }, null, 8, ["payload", "errors", "onChanged"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}